export default __webpack_public_path__ + "static/media/arch_of_dots.f84b35e1.png";